import { callFunction } from "./functions-client";

// API-key integrations (LOS Phase 19).
export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

export const listApiKeys = () =>
  callFunction<{ keys: ApiKey[] }>("integration/keys", { method: "GET" });

// Returns the full key exactly once — surface it immediately, it can't be shown again.
export const createApiKey = (name: string) =>
  callFunction<{ key: string; api_key: ApiKey }>("integration/key-create", { body: { name } });

export const revokeApiKey = (id: string) =>
  callFunction<{ ok: boolean }>("integration/key-revoke", { body: { id } });
